import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "./Weather.css";
import WeatherForecast from "./WeatherForecast.js";
import WeatherInfo from "./WeatherInfo";

export default function Weather(props) {
  const [city, setCity] = useState(props.defaultCity);
  const [weatherData, setWeatherData] = useState({ ready: false });

  function handleResponse(response) {
    console.log(response);
    setWeatherData({
      ready: true,
      city: response.data.city,
      temperature: response.data.temperature.current,
      date: new Date(response.data.time * 1000),
      description: response.data.condition.description,
      icon: response.data.condition.icon,
      humidity: response.data.temperature.humidity,
      wind: response.data.wind.speed,
      coordinates: response.data.coordinates,
    });
  }
  function search() {
    const apiKey = `25d6coae8fb5tfc0aa42170aacf42234`;
    const apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}`;
    axios.get(apiUrl).then(handleResponse);
  }
  function handleSubmit(event) {
    event.preventDefault();
    search();
  }
  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <>
        <div className="Weather ">
          <div className="container ">
            <form className="mb-3 shadow" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-9">
                  <input
                    type="search"
                    placeholder="Type a city.."
                    className="form-control "
                    autoComplete="off"
                    onChange={handleCityChange}
                  />
                </div>
                <div className="col-3">
                  <input
                    type="submit"
                    value="Search"
                    className="btn btn-dark w-100"
                  />
                </div>
              </div>
            </form>
            <WeatherInfo info={weatherData} />
            <WeatherForecast coordinates={weatherData.coordinates} />
          </div>
        </div>
        <p>
          <a
            className="link-light"
            href="https://github.com/julianaBabii/react-weather-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open-source
          </a>{" "}
          coded by Juliana Babii{" "}
        </p>
      </>
    );
  } else {
    search();
    return "Loading...";
  }
}
